// extracted by mini-css-extract-plugin
export default {"number":"number___b07acb091614f640","control":"control___a073739aef2c4188"};